module.exports = __webpack_public_path__ + "static/media/plus-blue.9854caae.svg";